import { useRef } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import InitialLoadingAnimation from './InitialLoadingAnimation';
import WelcomeText from './WelcomeText';
import SellBuyDecisionDivider from './SellBuyDecisionDivider';

const Hero = () => {
  const { t } = useTranslation();
  const sellBuyDecisionRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLDivElement>(null);

  const scrollDown = () => {
    if (!window) return;
    window.scroll({ top: window.scrollY + window.innerHeight, behavior: 'smooth' });
  }

  return (
    <section className="py-12 px-4 lg:px-8 bg-white w-screen">
      <WelcomeText scrollDown={scrollDown} t={t} ref={textRef} />
      <InitialLoadingAnimation textRef={textRef} sellBuyDecisionRef={sellBuyDecisionRef} />
      <SellBuyDecisionDivider t={t} ref={sellBuyDecisionRef} />
    </section>
  );
}

export default Hero;
